import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="repeatable-fields"
// Clones a <template> to add repeatable form rows, and removes a row on click.
// Inputs inside a <template> are inert, so the blank row is never submitted
// until it's added.
//
// Usage:
//   <div data-controller="repeatable-fields">
//     <div data-repeatable-fields-target="list">
//       <div data-repeatable-fields-target="row">
//         <input name="thing[][key]">
//         <button data-action="repeatable-fields#remove">Remove</button>
//       </div>
//     </div>
//     <template data-repeatable-fields-target="template">
//       <div data-repeatable-fields-target="row">...same markup, blank...</div>
//     </template>
//     <button data-action="repeatable-fields#add">Add</button>
//   </div>
//
export default class extends Controller {
  static targets = ["list", "template", "row"]

  add(event) {
    event.preventDefault()

    const row = this.templateTarget.content.firstElementChild.cloneNode(true)
    this.listTarget.appendChild(row)
    row.querySelector("input, select, textarea")?.focus()
  }

  remove(event) {
    event.preventDefault()

    const row = event.target.closest("[data-repeatable-fields-target='row']")
    if (!row) return

    row.remove()
    // Removing every row would leave nothing to type into, and an absent
    // param means "no change" server-side rather than "clear them all".
    if (this.rowTargets.length === 0) this.add(event)
  }
}
